import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PromoteursHeader from "./PromoteursHeader";
import UpdateCity from "./UpdateCity";
import { openModal } from "../../../redux/actions/modalActions";
import { useDispatch } from "react-redux";

const CitiesList = () => {
  const dispatch = useDispatch();
  const { loading, cities } = useSelector((state) => state.citiesReducer);
  const [searchfilter, setSearchfilter] = useState("");
  const [filteredSortedCities, setFilteredSortedCities] = useState([]);
  const [sortField, setSortField] = useState("name");
  const [sortDirection, setSortDirection] = useState("asc");
  const [activeMenuId, setActiveMenuId] = useState(null);

  const handleUpdateCity = (city) => {
    dispatch(
      openModal({
        title: `Ajouter des images à ${city.name}`,
        content: <UpdateCity city={city} />,
      })
    );
  };

  const toggleMenu = (id, e) => {
    e.stopPropagation();
    setActiveMenuId(activeMenuId === id ? null : id);
  };

  useEffect(() => {
    let filtered = cities.filter((city) =>
      city.name.toLowerCase().includes(searchfilter.toLowerCase())
    );

    filtered = filtered.sort((a, b) => {
      let aValue = getFieldValue(a, sortField);
      let bValue = getFieldValue(b, sortField);

      if (typeof aValue === "string") aValue = aValue.toLowerCase();
      if (typeof bValue === "string") bValue = bValue.toLowerCase();

      if (aValue < bValue) return sortDirection === "asc" ? -1 : 1;
      if (aValue > bValue) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });

    setFilteredSortedCities(filtered);
  }, [cities, searchfilter, sortField, sortDirection]);

  const getFieldValue = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc?.[part], obj);
  };

  const handleSort = (field) => {
    if (field === sortField) {
      // Toggle direction
      setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  return (
    <div>
      <PromoteursHeader
        searchfilter={searchfilter}
        setSearchfilter={setSearchfilter}
        handleItemSearch={null}
        showButton={false}
      />
      <div className="bg-white bold d-flex radius05 my-2 p-3 pink ">
        <div className="flex-1 pointer" onClick={() => handleSort("name")}>
          Ville
        </div>
        <div className="flex-1 pointer" onClick={() => handleSort("code")}>
          Code
        </div>
        <div className="flex-1">Position</div>
        <div
          className="flex-1 pointer"
          onClick={() => handleSort("programmes.count")}
        >
          Programmes
        </div>
        <div
          className="flex-1 pointer"
          onClick={() => handleSort("lots.count")}
        >
          Lots
        </div>
        <div
          className="flex-1 pointer"
          onClick={() => handleSort("images.length")}
        >
          Images
        </div>
        <div className="w5 text-center">Actions</div>
      </div>
      <div className="d-flex gap-2 flex-column">
        {filteredSortedCities.map((city) => (
          <div key={city.id} className="bg-white bold d-flex radius05 my-2 p-3">
            <div className="flex-1 d-flex align-items-center">{city.name}</div>
            <div className="flex-1 d-flex align-items-center">{city.code}</div>
            <div className="flex-1 d-flex align-items-center">{`${
              city.latitude || "-"
            } ${city.longitude || "-"}`}</div>
            <div className="flex-1 d-flex align-items-center">
              {city.programmes.count}
            </div>
            <div className="flex-1 d-flex align-items-center">
              {city.lots.count}
            </div>
            <div className="flex-1 d-flex align-items-center">
              {city.images.length}
            </div>
            <div className="w5 text-center">
              <div className="dotsMenu" onClick={(e) => e.stopPropagation()}>
                <button
                  className="border-0 bg-none p-2"
                  onClick={(e) => toggleMenu(city.id, e)}
                >
                  <img
                    src="./icons/dots-menu.svg"
                    alt="menu"
                    height={25}
                    width={25}
                  />
                </button>
                {activeMenuId === city.id && (
                  <div className="dots-menu-modal border">
                    <div
                      className="dots-menu-item text-start"
                      onClick={(e) => {
                        handleUpdateCity(city);
                        setActiveMenuId(null);
                      }}
                    >
                      + images
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CitiesList;
